<template>
    <div class="_content">
        <div class="item-box3">
            {{ uploadDetail.serviceDetailName }}
        </div>
        <div class="_content1">

            <!-- <div class="item-box">
            <div class="title car-province">
                <div>车牌号码</div>
                <div class="col-province" @click="showAllProv=true;showNoBoard=false">
                    <div>{{province}}</div>
                    <img src="~@/imgs/arrow-down2.png" alt="">
                </div>
            </div>
            <input class="val" type="text" v-model="carNo" @click="showNoBoard=true;showAllProv=false" placeholder="请输入车牌号码" readonly>

            <platen
                :showNoBoard="showNoBoard"
                @closeCarNO="showNoBoard = false"
                :chooseCarNO="chooseCarNo"
                :delect="delect"
                :province="province"
                :selectCarNo='carNo'
                :showTitleBtn='true'
            >
            </platen>
        </div> -->

            <!-- 省键盘 -->
            <div class="provinces" v-if="showAllProv" ref="provinces">
                <div class="prolist">
                    <div v-for="(item, index) in provinces" :key="index" :class="province === item ? 'selected' : ''"
                        @click="chooseProvince(item)">{{ item }}</div>
                </div>
            </div>

            <div class="item-box2">
                <div class="box-cont">
                    <div class="title bottom-line">
                        <div>图片资料</div>
                        <div class="title-right" @click="showPupup = !showPupup">
                            查看范例
                            <img src="~@/imgs/arrow-right-grey2.png" alt="">
                        </div>
                    </div>

                    <!-- 上传图片 保养-->
                    <div class="cont">
                        <div class="li" v-for="(item, index) in filteredCarWashList" :key="index">
                            <div v-if="photoMap[item.isShow]" class="upload-img"
                                v-upload="{ onUpload: upload, vin: false, index: item.imgType, refresh: true }">
                                <img v-show="!photoList[item.imgType]" class="car" src="~@/imgs/car.png" alt="">
                                <img v-show="!photoList[item.imgType]" class="camera" src="~@/imgs/camera.png" alt="">
                                <img v-show="photoList[item.imgType]" class="upload-img" :src="photoList[item.imgType]"
                                    alt="" />
                                <img v-show="photoList[item.imgType]" @click.stop="photoList[item.imgType] = ''"
                                    class="uploadClose" src="~@/imgs/close.png" alt="">
                            </div>
                            <div v-if="photoMap[item.isShow]" class="tips">{{ item.text }}<span v-if="item.required"
                                    class="themeColor"> *</span></div>
                        </div>
                    </div>

                </div>
                <div v-if="photoMap.safeCheckReport">
                    <div class="box-cont2">
                        <div class="title">
                            <div style="font-size:0.75rem; font-weight: 550">安全检测结果建议</div>
                            <div class="title-right">
                                <div v-show="isCheck"
                                    class="van-checkbox__icon van-checkbox__icon--square van-checkbox__icon--checked"
                                    style="font-size: 12px;" @click="handleCheckAll">
                                    <i class="van-icon van-icon-success"></i>
                                </div>
                                <div v-show="!isCheck" class="van-checkbox__icon van-checkbox__icon--square"
                                    style="font-size: 12px;" @click="handleCheckAll">
                                    <i class="van-icon van-icon-success"></i>
                                </div>
                                <span style="margin-left:3px;">全部已通过</span>
                            </div>
                        </div>
                        <div class="cont">
                            <van-cell-group inset>
                                <van-field v-model="safeCheckResultAdvise" rows="3" autosize type="textarea"
                                    maxlength="300" placeholder="请输入留言" show-word-limit />
                            </van-cell-group>
                        </div>
                    </div>
                    <!--检测项目根据分组为10项标准安全检测或18项快捷安全检测-->
                    <div class="box-cont3" v-for="(item, index) in filteredSafeCheckContent" :key="index">
                        <div class="title">
                            <div class="title-label">{{ item.checkId }} 、 {{ item.checkName }}</div>
                            <div class="title-right">
                                <div v-show="item.pass === 1"
                                    class="van-checkbox__icon van-checkbox__icon--square van-checkbox__icon--checked"
                                    style="font-size: 12px;" @click="handleCheck(item)">
                                    <i class="van-icon van-icon-success"></i>
                                </div>
                                <div v-show="item.pass === 0" class="van-checkbox__icon van-checkbox__icon--square"
                                    style="font-size: 12px;" @click="handleCheck(item)">
                                    <i class="van-icon van-icon-success"></i>
                                </div>
                                <span style="margin-left:3px;">{{ item.pass === 1 ? '已通过' : '未通过' }}</span>
                            </div>
                        </div>
                        <div class="cont">
                            <div class="li">
                                <p>{{ item.checkContent }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="box-cont4" @click="showALL = !showALL">
                        {{ showALL ? '收起' : '展开剩余7条' }}
                    </div>
                    <div class="box-cont">
                        <div class="title bottom-line">
                            <div>客户签名</div>
                            <div class="title-right">
                                <van-radio-group v-model="signatureType" direction="horizontal" icon-size="12">
                                    <van-radio :name="1">在线签名</van-radio>
                                    <van-radio :name="2">签名图片</van-radio>
                                </van-radio-group>
                            </div>
                        </div>
                        <div class="cont">
                            <div class="li">
                                <!--在线签名显示-->
                                <div v-show="signatureType === 1" class="upload-img2" @click="toOnlineSign">
                                    <img v-if="signatureUrl" class="upload-img" :src="signatureUrl" alt="" />
                                    <!-- <img class="camera" src="~@/imgs/operation.png" alt=""> -->
                                    <img v-else class="camera" src="~@/imgs/pen.png" alt="">
                                </div>
                                <!--签名图片显示-->
                                <div v-show="signatureType === 2" class="upload-img2"
                                    v-upload="{ onUpload: uploadSignature, vin: false, refresh: true }">
                                    <img v-if="signatureUrl" class="upload-img" :src="signatureUrl" alt="" />
                                    <!-- <img class="camera" src="~@/imgs/operation.png" alt=""> -->
                                    <img v-else class="camera" src="~@/imgs/grayCamera.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <van-popup v-model="showPupup" round closeable position="bottom" class="popup-about">
                <div class="content-block">
                    <p class="tt">图片资料范例</p>
                    <p class="tip marginTop fmarginBottom">请按照示例上传完整清晰图片</p>

                    <div v-if="photoMap.isVehicleWorkingPhoto" class="img2">
                        <img src="~@/imgs/image/car.png" alt="" />
                        <div class="marginTop marginBottom textAlignCenter">
                            <span style="color:#0081F3">
                                能清晰显露车牌及车店的作业中照片
                            </span>
                            示意图
                        </div>
                    </div>

                    <div v-if="photoMap.isWorkingPhoto" class="img2">
                        <img src="~@/imgs/image/car_3.png" alt="" />
                        <div class="marginTop marginBottom textAlignCenter">
                            <span style="color:#0081F3">
                                作业中照片
                            </span>
                            示意图
                        </div>
                    </div>

                    <div v-if="photoMap.isVehicleOilPhoto" class="img2">
                        <img src="~@/imgs/image/car_2.png" alt="" />
                        <div class="marginTop marginBottom textAlignCenter">
                            <span style="color:#0081F3">
                                使用的机油与车辆合影照片
                            </span>
                            示意图
                        </div>
                    </div>

                    <div v-if="photoMap.isWorkOrderPhoto" class="img2">
                        <img src="~@/imgs/image/car_4.png" alt="" />
                        <div class="marginTop marginBottom textAlignCenter">
                            <span style="color:#0081F3">
                                工单照片
                            </span>
                            示意图
                        </div>
                    </div>

                    <div v-if="photoMap.carLiftPhoto" class="img2">
                        <img src="~@/imgs/image/car_5.png" alt="" />
                        <div class="marginTop marginBottom textAlignCenter">
                            <span style="color:#0081F3">
                                车辆在起升架上的照片
                            </span>
                            示意图
                        </div>
                    </div>

                    <div v-if="photoMap.hoodOpenPhoto" class="img2">
                        <img src="~@/imgs/image/car_6.png" alt="" />
                        <div class="marginTop marginBottom textAlignCenter">
                            <span style="color:#0081F3">
                                引擎盖打开的照片
                            </span>
                            示意图
                        </div>
                    </div>

                    <div v-if="photoMap.puttyingPhoto" class="img2">
                        <img src="https://res.xiaokunkeji.cn/image/2025/12/22/78bb17d304294a51a4d49cd660f428db.jpg"
                            alt="" />
                        <div class="marginTop marginBottom textAlignCenter">
                            <span style="color:#0081F3">
                                刮腻子照片
                            </span>
                            示意图
                        </div>
                    </div>

                    <div v-if="photoMap.isVinPhoto || photoMap.isVehicleWorkingPhoto" class="img2">
                        <img src="https://res.xiaokunkeji.cn/image/2026/01/13/db02a6572ec54e498122c9e66b473976.jpg"
                            alt="" />
                        <div class="marginTop marginBottom textAlignCenter">
                            <span style="color:#0081F3">
                                车架号图片
                            </span>
                            示意图
                        </div>
                    </div>

                    <div @click="showPupup = false">
                        <tt-button text="知道了"></tt-button>
                    </div>
                </div>
            </van-popup>

            <div class="btn verify-btn" @click="sureToOff()">
                <tt-button text="立即核销" />
            </div>
        </div>
        <!-- 限制可使用车牌 -->
        <van-popup v-model="showOrcCarNoTip" class=" infocustorm">
            <p class="title">提示</p>
            <p class="text">
                识别车牌为：<span style="color:#4078ff;">{{ orcCarNo }}</span><br>
                与限制可使用车牌不一致<br>
                请正面拍摄车牌照上传
            </p>
            <p class="btn" @click="showOrcCarNoTip = false">重新上传</p>
        </van-popup>

    </div>
</template>

<script>
import platen from '@/components/platen'
import ttButton from '@/components/ttButton'
import config from '@/configs/config'

const carParams = {
    province: '沪',
    provinces: ['京', '沪', '浙', '苏', '粤', '鲁', '晋', '冀', '豫', '川', '渝', '辽', '吉', '黑', '皖', '鄂', '湘', '赣', '闽', '陕', '甘', '宁', '蒙', '津', '贵', '云', '桂', '琼', '青', '新', '藏', '港', '澳'],
    carNo: '',
    showAllProv: false,
    showNoBoard: false
}
export default {
    components: {
        ttButton,
        platen
    },
    data() {
        return {
            safeCheckResultAdvise: '',
            lock: false,
            isOnlineSign: true, //客户签名是否选择在线签名
            isCheck: true, //全部通过
            validateCarNo: null, //需要验证的车牌号码
            orcCarNo: null, // OCR识别到的车牌号码
            showOrcCarNoTip: false,
            uploadDetail: {},
            sId: '',
            vCode: '',
            ...carParams,
            showPupup: false,
            imgType: '',
            orderType: '',
            showALL: false,
            signatureType: 1, // 签名类型 1在线 2图片
            signatureUrl: '', //签名图片url
            safeCheckContent: [
                {
                    checkId: 1,
                    checkName: "发动机检测",
                    checkContent: "机油量、防冻液、空气格、水箱、火花塞等",
                    pass: 1
                },
                {
                    checkId: 2,
                    checkName: "变速器检测",
                    checkContent: "变速箱油量；变速箱换挡平顺性；档位性能",
                    pass: 1
                },
                {
                    checkId: 3,
                    checkName: "转向系统检测",
                    checkContent: "四轮定位、助力油、平衡杆球头及衬套、方向机及防尘套等",
                    pass: 1
                },
                {
                    checkId: 4,
                    checkName: "底盘检测",
                    checkContent: "减震器及顶胶、方向机、拉杆球头等",
                    pass: 1
                },
                {
                    checkId: 5,
                    checkName: "汽车玻璃检测",
                    checkContent: "划痕、破损、检查天窗等",
                    pass: 1
                },
                {
                    checkId: 6,
                    checkName: "汽车电子系统检测",
                    checkContent: "仪表灯、灯光、喇叭、雨刷等",
                    pass: 1
                },
                {
                    checkId: 7,
                    checkName: "车内环境检测",
                    checkContent: "备箱灯、遮阳板灯光、阅读灯、安全带等",
                    pass: 1
                },
                {
                    checkId: 8,
                    checkName: "轮胎检测",
                    checkContent: "轮胎裂纹、钉子、轮盖等",
                    pass: 1
                },
                {
                    checkId: 9,
                    checkName: "蓄电池检测",
                    checkContent: "电池线路老化检测、蓄电池电压检测",
                    pass: 1
                },
                {
                    checkId: 10,
                    checkName: "车辆综合安全检测",
                    checkContent: "驾驶室及车身部分、发动机部分、底盘部分",
                    pass: 1
                }
            ],
            carWashList: {
                'NO_APPOINTMENT_SHOP_ORDER': [
                    {
                        imgType: 'vehicleWorkingPhoto',
                        text: '能清晰显露车牌及车店的作业中照片',
                        required: true,
                        isShow: 'isVehicleWorkingPhoto'
                    }, {
                        imgType: 'elseWorkPhoto',
                        text: '其他图片',
                        required: false,
                        isShow: 'isElseWorkPhoto'
                    }, {
                        imgType: 'carLiftPhoto',
                        text: '车辆在起升架上的照片',
                        required: true,
                        isShow: 'carLiftPhoto'
                    }, {
                        imgType: 'hoodOpenPhoto',
                        text: '引擎盖打开的照片',
                        required: true,
                        isShow: 'hoodOpenPhoto'
                    },
                    {
                        imgType: 'vinPhoto',
                        text: '车架号图片',
                        required: true,
                        isShow: 'isVinPhoto'
                    }
                ],
                'SHOP_ORDER': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'beforeWorkPhoto',
                    text: '作业前漆面照片',
                    required: true,
                    isShow: 'isBeforeWorkPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'afterWorkPhoto',
                    text: '作业后漆面照片',
                    required: true,
                    isShow: 'isAfterWorkPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                },
                {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'LACQURE_SHOP_ORDER': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'beforeWorkPhoto',
                    text: '作业前漆面照片',
                    required: true,
                    isShow: 'isBeforeWorkPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'afterWorkPhoto',
                    text: '作业后漆面照片',
                    required: true,
                    isShow: 'isAfterWorkPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                }, {
                    imgType: 'puttyingPhoto',
                    text: '刮腻子照片',
                    required: true,
                    isShow: 'puttyingPhoto'
                },
                {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'MAINTAIN_ORDER': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'vehicleOilPhoto',
                    text: '使用的机油与车辆合影照片',
                    required: true,
                    isShow: 'isVehicleOilPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                },
                {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'MICRO_REPAIR_ORDER': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'beforeWorkPhoto',
                    text: '作业前漆面照片',
                    required: true,
                    isShow: 'isBeforeWorkPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'afterWorkPhoto',
                    text: '作业后漆面照片',
                    required: true,
                    isShow: 'isAfterWorkPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                }, {
                    imgType: 'puttyingPhoto',
                    text: '刮腻子照片',
                    required: false,
                    isShow: 'puttyingPhoto'
                },
                {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'RESERVE_SHOP': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'beforeWorkPhoto',
                    text: '作业前漆面照片',
                    required: true,
                    isShow: 'isBeforeWorkPhoto'
                }, {
                    imgType: 'workingPhoto',
                    text: '作业中照片',
                    required: true,
                    isShow: 'isWorkingPhoto'
                }, {
                    imgType: 'afterWorkPhoto',
                    text: '作业后漆面照片',
                    required: true,
                    isShow: 'isAfterWorkPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                },
                {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }],
                'NO_RESERVE_SHOP_SERVICE': [{
                    imgType: 'vehicleWorkingPhoto',
                    text: '能清晰显露车牌及车店的作业中照片',
                    required: true,
                    isShow: 'isVehicleWorkingPhoto'
                }, {
                    imgType: 'workOrderPhoto',
                    text: '工单照片',
                    required: true,
                    isShow: 'isWorkOrderPhoto'
                }, {
                    imgType: 'elseWorkPhoto',
                    text: '其他图片',
                    required: false,
                    isShow: 'isElseWorkPhoto'
                }, {
                    imgType: 'carLiftPhoto',
                    text: '车辆在起升架上的照片',
                    required: true,
                    isShow: 'carLiftPhoto'
                }, {
                    imgType: 'hoodOpenPhoto',
                    text: '引擎盖打开的照片',
                    required: true,
                    isShow: 'hoodOpenPhoto'
                },
                {
                    imgType: 'vinPhoto',
                    text: '车架号图片',
                    required: true,
                    isShow: 'isVinPhoto'
                }]
            },
            photoMap: {
                isVinPhoto: false, //车架号图片
                isVehicleWorkingPhoto: false,   //车辆与门店合照
                isVehicleOilPhoto: false,     //机油和车辆合照
                isBeforeWorkPhoto: false,    //  作业前照片
                isAfterWorkPhoto: false,     //  作业后照片
                isWorkingPhoto: false,      // 作业中照片
                isWorkOrderPhoto: false,    // 工单照片
                isElseWorkPhoto: false,     //其他照片
                carLiftPhoto: false,     //车辆在起升架上的照片
                hoodOpenPhoto: false,    //引擎盖打开的照片
                puttyingPhoto: false, //刮腻子照片
                safeCheckReport: false     //安全检测电子检测报告
            },
            photoList: {
                vinPhoto: '', //车架号图片
                vehicleWorkingPhoto: '', // 显露车牌及车店一体的作业中照片  
                vehicleOilPhoto: '', // 使用的机油与车辆合影照片
                beforeWorkPhoto: '', // 作业前照片
                afterWorkPhoto: '', // 作业后照片
                workingPhoto: '', // 作业中照片
                workOrderPhoto: '', // 工单照片
                elseWorkPhoto: '', // 其他照片
                carLiftPhoto: '',     //车辆在起升架上的照片
                hoodOpenPhoto: '',    //引擎盖打开的照片
                puttyingPhoto: '', //刮腻子照片
            }
        }
    },
    created() {
        this.uploadDetail = this.options && this.options.uploadDetail ? this.options.uploadDetail : JSON.parse(tuhu.sessionStorage.getItem('upDetail') || null)
        this.photoMap = JSON.parse(this.uploadDetail.photoMap)
        const serviceGroupId = this.uploadDetail.serviceGroupId
        const checkType = this.uploadDetail.checkType
        //10项对应的分组ID=86标准安全检测，第3项的描述说明有：四轮定位,18项对应的分组ID=73快捷安全检测，第3项的描述说明没有：四轮定位
        if (serviceGroupId === 73 && checkType === 2) {
            const foundItem = this.safeCheckContent.find(item => item.checkId === 3);
            if (foundItem) {
                foundItem.checkContent = '助力油、平衡杆球头及衬套、方向机及防尘套等';
            }
        }
        this.sId = tuhu.getParam('sId')
        this.vCode = tuhu.getParam('vCode')
        this.validateCarNo = tuhu.getParam('carNo')
        this.isCheckCarNo = tuhu.getParam('isCheckCarNo') === '1'
        this.orderType = this.uploadDetail.orderType
    },
    mounted() {
        // 监听在线签名的图片URL
        window.addEventListener('message', (event) => {
            if (event.data) {
                this.$set(this, 'signatureUrl', event.data)
            }
        });
    },
    computed: {
        filteredSafeCheckContent() {
            return this.showALL ? this.safeCheckContent : this.safeCheckContent.slice(0, 3);
        },
        //防止盒子多余渲染影响页面布局
        filteredCarWashList() {
            const photoList = this.carWashList[this.orderType].map(item => {
                if (item.imgType === 'vinPhoto' && this.photoMap['isVehicleWorkingPhoto']) {
                    return {
                        ...item,
                        required: this.photoMap['isVinPhoto'] ? true : false,
                        isShow: 'isVehicleWorkingPhoto'
                    };
                }
                return item; // 其他项保持不变
            });

            return this.orderType && this.photoMap
                ? photoList.filter(item => this.photoMap[item.isShow])
                : []
        }
    },
    methods: {
        //全选通过
        handleCheckAll() {
            this.isCheck = !this.isCheck
            if (this.isCheck) {
                this.safeCheckContent.forEach(item => { item.pass = 1 })
            } else {
                this.safeCheckContent.forEach(item => { item.pass = 0 })
            }
        },
        //单选通过
        handleCheck(item) {
            item.pass === 1 ? item.pass = 0 : item.pass = 1
            // 判断是否全选
            const passedItems = this.safeCheckContent.filter(item => item.pass === 1)
            if (passedItems.length === 10) this.isCheck = true
            else this.isCheck = false
        },
        chooseProvince(item) {
            this.province = item
            this.showAllProv = false
            this.showNoBoard = true
        },
        chooseCarNo(val) {
            this.carNo = val
        },
        delect() {
            this.carNo = this.carNo.slice(0, -1)
        },
        // 跳转在线签名
        toOnlineSign() {
            tuhu.navigateTo({
                url: "/pages/orderDetail/onlineSign",
            });
        },
        upload(val) {
            if (val && val.code === '200') {
                this.photoList[val.index] = val.data
            } else {
                tuhu.toast(val.message || '网络错误')
            }
        },
        // 保存签名图片url
        uploadSignature(val) {
            if (val && val.code === '200') {
                this.signatureUrl = val.data
            } else {
                tuhu.toast(val.message || '网络错误')
            }
        },
        async sureToOff() {

            let res = this.ckeckImg()

            if (!res) return

            if (this.lock) return

            this.lock = true

            this.orcCarNo = null

            tuhu.showIndicator()
            try {

                //必传项
                const baseParams = {
                    ...this.photoList,
                    shopId: this.sId,
                    code: this.vCode,
                    carNo: this.validateCarNo,
                    isOcr:  this.isCheckCarNo && this.photoMap.isVehicleWorkingPhoto ? '1' : '0', //是否需要ocr识别，车店合照需要ocr识别获取车牌号 
                }
                let params = this.photoMap.safeCheckReport ? {
                    ...baseParams,
                    //根据photoMap.safeCheckReport判断后边的值需不需要传
                    safeCheckContent: this.safeCheckContent,
                    safeCheckResultAdvise: this.safeCheckResultAdvise,
                    signature: {
                        signatureType: this.signatureType,
                        signatureUrl: this.signatureUrl,
                    },
                } : baseParams

                const data = await tuhu.fetch(`${config.apis.GET_CODE_COUPON}`, {

                    method: 'post',

                    body: JSON.stringify(params)

                })
                if ( this.isCheckCarNo && this.photoMap['isVehicleWorkingPhoto'] && data && data.code === '10003') {
                    tuhu.hideIndicator()
                    this.lock = false
                    this.orcCarNo = data.data.orcCarNo
                    if (!this.orcCarNo) return tuhu.toast('车牌识别校验失败，请重新上传能清晰显露车牌及车店的作业中照片' || '网络错误')
                    this.showOrcCarNoTip = true
                }


                else if (data && data.code === '200') {


                    tuhu.hideIndicator()

                    this.lock = false

                    tuhu.toast('核销成功')

                    let info = Object.assign(data.data, {
                        Message: data.message
                    })

                    tuhu.sessionStorage.setItem('shopOrderDetail', JSON.stringify(info))

                    setTimeout(() => {

                        tuhu.redirectTo({

                            url: '/pages/orderDetail/index',

                            data: {

                                ListInfo: info

                            },

                            query: {

                                success: data.code === '200' ? 1 : ''

                            }

                        })

                    }, 300)

                } else {

                    tuhu.hideIndicator()

                    this.lock = false

                    tuhu.toast(data.message || '网络错误')

                }

            } catch (e) {
                tuhu.hideIndicator()

                this.lock = false

                console.log(e)

            }

        },
        ckeckImg() {

            if (!this.photoList.vinPhoto && this.photoMap.isVinPhoto) return tuhu.toast('请上传车架号图片')

            if (!this.photoList.vehicleWorkingPhoto && this.photoMap.isVehicleWorkingPhoto) return tuhu.toast('请上传显露车牌及车店一体的作业中照片')

            if (!this.photoList.vehicleOilPhoto && this.photoMap.isVehicleOilPhoto) return tuhu.toast('请上传使用的机油与车辆合影照片')

            if (!this.photoList.beforeWorkPhoto && this.photoMap.isBeforeWorkPhoto) return tuhu.toast('请上传作业前照片')

            if (!this.photoList.afterWorkPhoto && this.photoMap.isAfterWorkPhoto) return tuhu.toast('请上传作业后照片')

            if (!this.photoList.workingPhoto && this.photoMap.isWorkingPhoto) return tuhu.toast('请上传作业中照片')

            if (!this.photoList.workOrderPhoto && this.photoMap.isWorkOrderPhoto) return tuhu.toast('请上传工单照片')

            if (!this.photoList.carLiftPhoto && this.photoMap.carLiftPhoto) return tuhu.toast('请上传车辆在起升架上的照片')

            if (!this.photoList.hoodOpenPhoto && this.photoMap.hoodOpenPhoto) return tuhu.toast('请上传引擎盖打开的照片')

            if (!this.safeCheckResultAdvise && this.photoMap.safeCheckReport) return tuhu.toast('请输入安全检测结果建议')

            if (!this.signatureType && this.photoMap.safeCheckReport) return tuhu.toast('请选择签名方式')

            if (!this.signatureUrl && this.photoMap.safeCheckReport) return tuhu.toast('请上传签名')

            if (this.orderType == 'LACQURE_SHOP_ORDER' && this.photoMap.puttyingPhoto && !this.photoList.puttyingPhoto) return tuhu.toast('请上传刮腻子照片')
            return true
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../css/provinceInput.css';

._content {
    background-image: linear-gradient(to bottom, #E6EAF1, #F3F5F7);

    .item-box3 {
        background-size: 100% auto;
        background-repeat: no-repeat, no-repeat;
        background-image: url('~@/imgs/carBg.png');
        font-size: 1rem;
        font-weight: 550;
        z-index: -1;
        width: 100%;
        padding-top: calc(7 / 15 * 18%);
        padding-left: 1rem;
        padding-bottom: calc(7 / 15 * 32% - 1.25rem);
    }
}

._content1 {
    display: flex;
    flex-direction: column;
    background-position: top;
    padding: 0 .75rem .75rem;

    .verify-btn {
        left: 0;
        right: 0;
        bottom: 1.75rem;
        position: fixed;
    }

    .item-box {
        display: flex;
        justify-content: space-between;
        position: relative;
        border-radius: .4rem;
        background: #fff;
        box-shadow: 0rem 0rem 0.6rem 0rem rgba(0, 0, 0, 0.04);
        padding: 0 1.1rem .75rem;
        z-index: 10001;

        .title {
            width: 4.4rem;
        }

        .val {
            flex: 1;
            margin-left: .5rem;
        }

        .car-province {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .col-province {
                justify-content: space-between;
                display: flex;
                align-items: center;
                background: rgb(0, 110, 239);
                border-radius: .2rem;

                >div {
                    color: #fff;
                    padding: .1rem .15rem;
                }

                >img {
                    width: .5rem;
                    height: .5rem;
                }
            }
        }
    }

    .item-box2 {
        flex: 1;
        margin-bottom: 4rem;

        .box-cont {
            display: flex;
            flex-direction: column;
            background: #fff;
            border-radius: .4rem;
            // margin-top: .5rem;
            box-shadow: 0rem 0rem 0.6rem 0rem rgba(0, 0, 0, 0.04);

            .title {
                display: flex;
                padding: .75rem;
                justify-content: space-between;

                .title-right {
                    display: flex;
                    align-items: center;

                    >img {
                        width: .8rem;
                        height: .8rem;
                    }
                }
            }

            .cont {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                padding: .75rem .85rem;

                .li {
                    margin-bottom: 1rem;

                    .upload-img {
                        position: relative;
                        width: 7rem;
                        height: 4.5rem;
                        background: url('~@/imgs/img-box.png') no-repeat;
                        background-size: 100% 100%;

                        .car {
                            width: 100%;
                            height: 100%;
                            padding: .2rem .3rem
                        }

                        .camera {
                            position: absolute;
                            height: 2rem;
                            width: 2rem;
                            top: 0;
                            bottom: 0;
                            left: 0;
                            right: 0;
                            margin: auto;
                        }

                        .uploadClose {
                            position: absolute;
                            width: 1rem;
                            height: 1rem;
                            top: .1rem;
                            right: .1rem;
                        }
                    }

                    .tips {
                        width: 6.5rem;
                        text-align: center;
                        margin-top: .2rem;
                    }

                    .upload-img2 {
                        position: relative;
                        width: 6.5rem;
                        height: 4rem;
                        background-size: 100% 100%;

                        .van-icon {
                            position: absolute;
                            height: 2rem;
                            width: 2rem;
                            top: 0;
                            bottom: 0;
                            left: 0;
                            right: 0;
                            margin: auto;
                        }
                    }
                }

            }
        }

        .box-cont2 {
            display: flex;
            flex-direction: column;
            background: #fff;
            border-radius: .4rem;
            margin-top: .5rem;

            .title {
                display: flex;
                padding: .75rem;
                justify-content: space-between;

                .title-right {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                }
            }

            .cont {
                display: flex;
                flex-direction: column;
                padding: .75rem;

                .van-cell {
                    border: 1px rgba(0, 0, 0, 0.04) solid;
                }
            }
        }

        .box-cont3 {
            display: flex;
            flex-direction: column;
            background: #fff;
            border-radius: .4rem;
            margin-top: .5rem;

            .title {
                display: flex;
                padding: .75rem;
                justify-content: space-between;

                .title-right {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                }

                .title-label {
                    font-size: .85rem;
                }
            }

            .cont {
                display: flex;
                flex-direction: column;
                padding: 0 .75rem .75rem;

                .li {
                    color: gray;
                }
            }
        }

        .box-cont4 {
            display: flex;
            justify-content: center;
            background: #fff;
            border-radius: .4rem;
            margin: .5rem 0;
            font-size: .75rem;
            color: #2875FF;
            padding: .75rem;
        }
    }

    /deep/.van-overlay {
        z-index: 10100 !important;
    }

    .popup-about {
        padding: .75rem;
        z-index: 11000 !important;
        box-sizing: border-box;
        height: 70vh;

        .content-block {
            margin: 0;

            .tt {
                font-size: 1rem;
                font-weight: 600;
            }

            .tip {
                color: rgb(255, 155, 15);
                font-size: .8rem;
            }
        }
    }

    //common
    @xkThemeCoder: #006EEF;

    .themeColor {
        // color: @xkThemeCoder;
        color: red;
    }

    .marginTop {
        margin-top: .5rem;
    }

    .marginBottom {
        margin-bottom: .5rem;
    }

    .textAlignCenter {
        text-align: center;
    }
}

.infocustorm {
    border-radius: 0.4rem;
    width: 80%;

    .title {
        font-size: 1rem;
        font-weight: 800;
        color: #323233;
        padding: 1.2rem 0;
        text-align: center;
    }

    .text {
        border-bottom: 1px solid #9e9e9e;
        padding: 0 1rem 1.2rem 1rem;
        line-height: 1.1rem;
        font-size: 0.8rem;
        color: #262f42;
        align-content: center;
        text-align: center;
    }

    .btn {
        height: 2.7rem;
        color: #275cd7;
        font-size: 0.8rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/verifyCode/verifyUploadImg.vue